"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcTimeInterval = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const TimeInterval_1 = __importDefault(require("../TimeInterval"));
function calcTimeInterval(interval, dateTime = (0, moment_timezone_1.default)(), unitsAgo = 0, endDate = (0, moment_timezone_1.default)()) {
    let from;
    let to;
    switch (interval) {
        case TimeInterval_1.default.DAY:
            from = dateTime.clone().tz('UTC').startOf('day').subtract(unitsAgo, 'day');
            to = endDate.isBefore(from.clone().endOf('day')) ? endDate : from.clone().endOf('day');
            return {
                from,
                to,
                label: from.format('DD MMM YYYY'),
            };
        case TimeInterval_1.default.WEEK:
            from = dateTime.clone().tz('UTC').startOf('week').subtract(unitsAgo, 'week');
            to = endDate.isBefore(from.clone().endOf('week')) ? endDate : from.clone().endOf('week');
            return {
                from,
                to,
                label: `${from.format('DD MMM')} - ${to.format('DD MMM')}`,
            };
        case TimeInterval_1.default.MONTH:
            from = dateTime.clone().tz('UTC').startOf('month').subtract(unitsAgo, 'month');
            to = endDate.isBefore(from.clone().endOf('month'))
                ? endDate
                : from.clone().endOf('month');
            return {
                from,
                to,
                label: from.format('MMM YYYY'),
            };
        case TimeInterval_1.default.QUARTER:
            from = dateTime.clone().tz('UTC').startOf('quarter').subtract(unitsAgo, 'quarter');
            to = endDate.isBefore(from.clone().endOf('quarter'))
                ? endDate
                : from.clone().endOf('quarter');
            return {
                from,
                to,
                label: `${from.format('MMM')} - ${to.format('MMM')}`,
            };
        case TimeInterval_1.default.YEAR:
            from = dateTime.clone().tz('UTC').startOf('year').subtract(unitsAgo, 'year');
            to = endDate.isBefore(from.clone().endOf('year')) ? endDate : from.clone().endOf('year');
            return {
                from,
                to,
                label: from.format('YYYY'),
            };
    }
}
exports.calcTimeInterval = calcTimeInterval;
exports.default = calcTimeInterval;
